(function ($) {
    "use strict";

    $(document).ready(function () {
        var outputText = '';

        $('.js-modal-open').on('click',function(){
            $('body').css('overflow', 'hidden');
            // $("body").append('<div id="modal-bg"></div>');
            //画面中央を計算する関数を実行
            modalResize();
            $('#modal-bg,.js-modal').fadeIn();
            outputText = ''

            $(window).resize(modalResize);
            function modalResize(){

                var w = $(window).width();
                var h = $(window).height();

                var cw = $(".js-modal").outerWidth();
                var ch = $(".js-modal").outerHeight();

                //取得した値をcssに追加する
                $(".js-modal").css({
                    "left": ((w - cw)/2) + "px",
                    "top": ((h - ch)/2) + "px"
                });
            }
            return false;
        });

        $('[name="qualification_none"]').click(function() {
            if ($('[name="qualification_none"]').is(':checked')) {
                $('[name="qualification[]"]').prop('disabled', true);
                $('[name="qualification[]"]').prop('checked', false);
                $('[name="qualification[]"]').parent().addClass('disabled');
                outputText += '資格なし/';
            }else{
                $('[name="qualification[]"]').prop('disabled', false);
                $('[name="qualification[]"]').parent().removeClass('disabled');
                outputText = '';
            }
        });

        //  税理士資格排他制御
        $('#jzd-qualification-tax_acc').click(function() {
            $('[name="qualification_none"]').prop('checked', false);
            if ($('#jzd-qualification-tax_acc').is(':checked')) {
                $('#jzd-qualification-tax_passed').prop('checked', false);
                $('#jzd-qualification-tax_passed').prop('disabled', true);

                $('#jzd-qualification-tax_passed').parent().addClass('disabled');
            }else{
                $('#jzd-qualification-tax_passed').prop('disabled', false);

                $('#jzd-qualification-tax_passed').parent().removeClass('disabled');
            }
        });
        $('#jzd-qualification-tax_passed').click(function() {
            $('[name="qualification_none"]').prop('checked', false);
            if ($('#jzd-qualification-tax_passed').is(':checked')) {
                $('#jzd-qualification-tax_acc').prop('checked', false);
                $('#jzd-qualification-tax_acc').prop('disabled', true);

                $('#jzd-qualification-tax_acc').parent().addClass('disabled');
            }else{
                $('#jzd-qualification-tax_acc').prop('disabled', false);

                $('#jzd-qualification-tax_acc').parent().removeClass('disabled');
            }
        });

        //  公認会計士資格排他制御
        $('#jzd-qualification-cpa').click(function() {
            $('[name="qualification_none"]').prop('checked', false);
            if ($('#jzd-qualification-cpa').is(':checked')) {
                $('#jzd-qualification-cpa_passed_paper').prop('checked', false);
                $('#jzd-qualification-cpa_passed_short').prop('checked', false);

                $('#jzd-qualification-cpa_passed_paper').prop('disabled', true);
                $('#jzd-qualification-cpa_passed_short').prop('disabled', true);

                $('#jzd-qualification-cpa_passed_paper').parent().addClass('disabled');
                $('#jzd-qualification-cpa_passed_short').parent().addClass('disabled');
            }else{
                $('#jzd-qualification-cpa_passed_paper').prop('disabled', false);
                $('#jzd-qualification-cpa_passed_short').prop('disabled', false);

                $('#jzd-qualification-cpa_passed_paper').parent().removeClass('disabled');
                $('#jzd-qualification-cpa_passed_short').parent().removeClass('disabled');
            }
        });

        $('#jzd-qualification-cpa_passed_paper').click(function() {
            $('[name="qualification_none"]').prop('checked', false);
            if ($('#jzd-qualification-cpa_passed_paper').is(':checked')) {

                $('#jzd-qualification-cpa_passed_short').prop('checked', false);
                $('#jzd-qualification-cpa').prop('checked', false);

                $('#jzd-qualification-cpa_passed_short').prop('disabled', true);
                $('#jzd-qualification-cpa').prop('disabled', true);

                $('#jzd-qualification-cpa').parent().addClass('disabled');
                $('#jzd-qualification-cpa_passed_short').parent().addClass('disabled');
            }else{
                $('#jzd-qualification-cpa_passed_short').prop('disabled', false);
                $('#jzd-qualification-cpa').prop('disabled', false);

                $('#jzd-qualification-cpa').parent().removeClass('disabled');
                $('#jzd-qualification-cpa_passed_short').parent().removeClass('disabled');
            }
        });

        $('#jzd-qualification-cpa_passed_short').click(function() {
            $('[name="qualification_none"]').prop('checked', false);
            if ($('#jzd-qualification-cpa_passed_short').is(':checked')) {
                $('#jzd-qualification-cpa_passed_paper').prop('checked', false);
                $('#jzd-qualification-cpa').prop('checked', false);

                $('#jzd-qualification-cpa_passed_paper').prop('disabled', true);
                $('#jzd-qualification-cpa').prop('disabled', true);

                $('#jzd-qualification-cpa').parent().addClass('disabled');
                $('#jzd-qualification-cpa_passed_paper').parent().addClass('disabled');

            }else{
                $('#jzd-qualification-cpa_passed_paper').prop('disabled', false);
                $('#jzd-qualification-cpa').prop('disabled', false);

                $('#jzd-qualification-cpa').parent().removeClass('disabled');
                $('#jzd-qualification-cpa_passed_paper').parent().removeClass('disabled');
            }
        });


        $('.js-modal-close').on('click',function(){


            $('[name="qualification[]"]:checked').each(function(index, elm) {
                var value = $(elm).attr('id');
                var text = $('label[for="' + value + '"]').text();
                outputText += text + '/';
            });

            if ($('[name="qualification_none"]').is(':checked')) {
                outputText ='';
                var text = $('label[for="jzd-qualification-_none"]').text();
                outputText += text + '/';
            }


            if(outputText == ''){
                $('#quali-btn').css('display','block');
                $('.selected-text').css('display','none');
                $('.selected-text').text(outputText);
            }else{
                outputText = outputText.slice( 0, -1 );
                $('#quali-btn').css('display','none');
                $('.selected-text').css('display','block');
                $('.selected-text').text(outputText);
            }

            //$('body').css('overflow', 'unset');
            $('body').css('overflow', '');
            $('#modal-bg,.js-modal').fadeOut();
            return false;
        });
    });
    $(window).on('load', function() {
        // ページ読み込み時に処理 チェックボックス
        var checkbox = $('.selected-qualification-id').text();
        var outputText = '';
        $('[name="qualification[]"]:checked').each(function(index, elm) {
          var value = $(elm).attr('id');
          var text = $('label[for="' + value + '"]').text();
          outputText += text + '/';
        });

        if ($('[name="qualification_none"]').is(':checked')) {
            outputText ='';
            var text = $('label[for="jzd-qualification-_none"]').text();
            outputText += text + '/';
        }


        if(outputText == ''){
            $('#quali-btn').css('display','block');
            $('.selected-text').css('display','none');
            $('.selected-text').text(outputText);
        }else{
            outputText = outputText.slice( 0, -1 );
            $('#quali-btn').css('display','none');
            $('.selected-text').css('display','block');
            $('.selected-text').text(outputText);
        }

        checkbox = checkbox.split('/');
        $.each(checkbox, function(index, value) {
            $('input[value="' + value +'"]').prop('checked', true);
        });

    });

})(jQuery);